import {
  SHIFT_PAYMENT_REQUEST_STATUS,
  SHIFT_STATUS,
  SHIFT_PAYMENT_STATUS,
  AUTH_STATUSES,
  SHIFT_ORIGIN,
  SHIFT_READY_FOR_PAYMENT_STATUS,
  SHIFT_NOT_READY_FOR_PAYMENT_FLAG,
  PAY_CODE_READY_FOR_PAY_STATUSES
} from './constants'

export default {
  getActiveShiftId(state) {
    return state.shift.shift?.id ?? undefined
  },
  getShiftPaymentRequestStatus() {
    return status => {
      return (
        SHIFT_PAYMENT_REQUEST_STATUS[status] ?? {
          title: status,
          color: '#6b7280'
        }
      )
    }
  },
  getPayCodeReadyForPayStatus() {
    return status => {
      const payCodeStatus = status === 'blocked' ? 'blocked' : 'unblocked'

      return (
        PAY_CODE_READY_FOR_PAY_STATUSES[payCodeStatus] ?? {
          title: payCodeStatus,
          color: '#10b981'
        }
      )
    }
  },
  getShiftPaymentStatus() {
    return status => {
      return (
        SHIFT_PAYMENT_STATUS[status] ?? {
          title: status,
          color: '#6b7280'
        }
      )
    }
  },
  getShiftStatus() {
    return status => {
      return (
        SHIFT_STATUS[status] ?? {
          title: status,
          color: '#6b7280',
          text: ''
        }
      )
    }
  },
  getReadyForPaymentStatus() {
    return status => {
      return (
        SHIFT_READY_FOR_PAYMENT_STATUS[status] ?? {
          title: status,
          color: '#6b7280'
        }
      )
    }
  },
  getNotReadyForPaymentFlag() {
    return flag => {
      return (
        SHIFT_NOT_READY_FOR_PAYMENT_FLAG[flag] ?? {
          title: flag,
          color: '#6b7280'
        }
      )
    }
  },
  getAuthType() {
    return type => {
      return (
        AUTH_STATUSES[type] ?? {
          title: type,
          color: AUTH_STATUSES.no_lunch_authorization.color,
          text: ''
        }
      )
    }
  },
  getOrigin() {
    return origin => {
      return origin ? (SHIFT_ORIGIN[origin] ?? SHIFT_ORIGIN.whereami) : SHIFT_ORIGIN.whereami
    }
  }
}
